import React from 'react';
import { Row, Col, Typography, Tooltip, Skeleton } from 'antd';
import { withTranslation } from 'react-i18next';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { DonutWithLegend, getCommonBarOptions } from './ChartShared';
import Colors from '../../../../../themes/Colors';

const { Text, Title } = Typography;

const containerCardStyle = {
  backgroundColor: Colors.snow,
  border: `1px solid ${Colors.border}`,
  borderRadius: '12px',
  padding: '8 16px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.02)',
  margin: 0
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '12px'
};

const AudienceCharts = ({ loading, socioEconomicData, genderData, ageRangeData, t }) => {
  return (
    <div>
      <div style={headerStyle}>
        <Title
          level={4}
          style={{
            margin: 0,
            fontSize: '16px',
            fontWeight: 700
          }}
        >
          {t('Audience detail')}
        </Title>
      </div>

      <Row gutter={[24, 24]} align="middle" style={containerCardStyle}>
        <Col xs={24} lg={8}>
          <div style={{ height: '160px' }}>
            <DonutWithLegend
              data={socioEconomicData}
              loading={loading}
              emptyMessage={t('No data available')}
            />
          </div>
        </Col>

        <Col xs={24} lg={8}>
          <div style={{ height: '160px', padding: '0 10px' }}>
            {loading ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                <Skeleton active paragraph={{ rows: 4 }} />
              </div>
            ) : ageRangeData ? (
              <Bar data={ageRangeData} options={getCommonBarOptions()} />
            ) : (
              <div
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Text type="secondary">{t('No data available')}</Text>
              </div>
            )}
          </div>
        </Col>

        <Col xs={24} lg={8}>
          <div style={{ height: '160px' }}>
            <DonutWithLegend
              data={genderData}
              loading={loading}
              emptyMessage={t('No data available')}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default withTranslation()(AudienceCharts);
